module.exports = __webpack_public_path__ + "static/media/prototype_logo.5ceb6a59.svg";